import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { RootState } from '../../../../store/root-reducer';
import ConnectEmailAccountCallback from './connect-whitelabel-email-account-callback';
import { EmailAccountMethod } from '../../../email-accounts/enums/email-account';
import { updateApplicationState } from '../../../home/home-slice';
import { verifyWhitelabelEmailAccountRequest } from '../../../email-accounts/extra-actions';

const mapStateToProps = (state: RootState) => ({
  status: state.emailAccount.verifyWhitelabelEmailAccountRequest.status,
  message: state.emailAccount.verifyWhitelabelEmailAccountRequest.message,
  error: state.emailAccount.verifyWhitelabelEmailAccountRequest.error,
  whitelabelEmailAccountResponse:
    state.emailAccount.whitelabelEmailAccountResponse,
});

const mapDispatchToProps = {
  sendVerifyEmailAccountRequest: (
    method: EmailAccountMethod,
    code: string,
    state?: string,
  ) => verifyWhitelabelEmailAccountRequest({ method, code, state }),
  handleHasUserConnectedEmailAccount: (hasUserConnectedEmailAccount: boolean) =>
    updateApplicationState({ hasUserConnectedEmailAccount }),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> &
  RouteComponentProps<{ method: EmailAccountMethod }>;

export default connector(ConnectEmailAccountCallback);
